import React, { useRef, useEffect, useState } from "react";
import PropTypes from "prop-types";

const VectorLogo = ({ path, style = {}, fill = "#FFFFFF" }) => {
  const pathRef = useRef(null);
  const [viewBox, setViewBox] = useState("0 0 24 24");

  useEffect(() => {
    if (!pathRef.current) return;
    const bbox = pathRef.current.getBBox();
    const padding = 2;
    setViewBox(
      `${bbox.x - padding} ${bbox.y - padding} ${bbox.width + 2 * padding} ${bbox.height + 2 * padding}`,
    );
  }, [path]);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={viewBox}
      style={{ display: "block", width: 100, height: 100, ...style }}
      preserveAspectRatio="xMidYMid meet"
    >
      <path ref={pathRef} d={path} fill={fill} />
    </svg>
  );
};

VectorLogo.propTypes = {
  path: PropTypes.string.isRequired,
  style: PropTypes.object,
  fill: PropTypes.string,
};

export default VectorLogo;
